import { useTranslation } from "react-i18next";
import { Vault, Lock, Plane, Globe2, ShieldCheck, FileText } from "lucide-react";

export default function ServicesPage() {
  const { t } = useTranslation();
  const services = [
    { icon: Vault, title: t("services.s1_t"), copy: t("services.s1_c") },
    { icon: Lock, title: t("services.s2_t"), copy: t("services.s2_c") },
    { icon: Plane, title: t("services.s3_t"), copy: t("services.s3_c") },
    { icon: Globe2, title: t("services.s4_t"), copy: t("services.s4_c") },
    { icon: ShieldCheck, title: t("services.s5_t"), copy: t("services.s5_c") },
    { icon: FileText, title: t("services.s6_t"), copy: t("services.s6_c") },
  ];

  return (
    <>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/80 mb-3">
          {t("services.kicker")}
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold tracking-tight max-w-4xl">
          {t("services.title")}
        </h1>
        <p className="mt-6 text-slate-300 max-w-2xl leading-relaxed">
          {t("services.subtitle")}
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={s.title}
              className="bg-[#0F1C3F]/80 backdrop-blur-md border border-amber-500/20 hover:border-amber-500/50 rounded-xl p-7 transition-all duration-300 hover:-translate-y-1"
              data-testid={`service-card-${i}`}
            >
              <div className="w-12 h-12 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mb-5">
                <s.icon className="w-5 h-5 text-amber-400" />
              </div>
              <div className="font-mono text-amber-400/70 text-xs mb-2">
                / {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-serif text-2xl text-slate-100 mb-3">{s.title}</h3>
              <p className="text-slate-400 leading-relaxed">{s.copy}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
